function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useEffect, useState } from 'react';
import _ from "lodash";
import { makeStyles } from '@material-ui/core/styles';
import ImageBase from "./ImageBase";
import FiltersOptions from "./ImageFiltersOptions";
const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  preview: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    marginBottom: theme.spacing(14)
  },
  footer: {
    position: "absolute",
    top: "auto",
    right: 0,
    left: 0,
    bottom: 0,
    paddingTop: theme.spacing(2),
    height: theme.spacing(14)
  }
}));

const EditImageFilters = (_ref) => {
  let className = _ref.className,
      imageUrl = _ref.imageUrl,
      _ref$imageCropdata = _ref.imageCropdata,
      imageCropdata = _ref$imageCropdata === void 0 ? {} : _ref$imageCropdata,
      _ref$imageFilters = _ref.imageFilters,
      imageFilters = _ref$imageFilters === void 0 ? {} : _ref$imageFilters,
      style = _ref.style,
      _ref$menu = _ref.menu,
      menu = _ref$menu === void 0 ? [] : _ref$menu,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "imageUrl", "imageCropdata", "imageFilters", "style", "menu", "onChange"]);

  const classes = useStyles();

  const handleChange = imageFilters => {
    onChange && onChange(imageFilters);
  };

  return React.createElement("div", {
    className: className || classes.root
  }, React.createElement("div", {
    className: classes.preview
  }, React.createElement(ImageBase, {
    imageCropdata: imageCropdata,
    imageFilters: imageFilters,
    imageUrl: imageUrl
  })), React.createElement("footer", {
    className: classes.footer
  }, React.createElement(FiltersOptions, {
    imageUrl: imageUrl,
    imageFilters: imageFilters,
    onChange: handleChange
  })));
};

export default EditImageFilters;